export const booleanRegexp = /^is([A-Z][a-zA-Z]+)/
export const headerRegexp =
  /<(.+)>; rel="http:\/\/www.w3.org\/ns\/hydra\/core#apiDocumentation"/
